import Component from './component';

Component.defaultProps = {
    className: null,
};
export default Component;
